// import React, { useState, useMemo } from "react";
// import { Link } from "react-router-dom";
// import { useAuth } from "../context/AuthContext";
// import { Button } from "../components/ui/button";
// import {
//   Card,
//   CardContent,
//   CardHeader,
//   CardTitle,
// } from "../components/ui/card";
// import { Input } from "../components/ui/input";
// import {
//   Select,
//   SelectContent,
//   SelectItem,
//   SelectTrigger,
//   SelectValue,
// } from "../components/ui/select";
// import { Badge } from "../components/ui/badge";
// import {
//   Stethoscope,
//   MapPin,
//   Clock,
//   Star,
//   Phone,
//   Award,
//   Search,
//   Filter,
//   Navigation,
//   UserPlus,
//   Crown,
//   AlertCircle,
// } from "lucide-react";
// import {
//   mockDoctors,
//   mockSpecialties,
//   generateWhatsAppLink,
//   mockUser,
// } from "../mock/mockData";
// import LocationService from "../services/locationService";

// const Doctors = () => {
//   const { isAuthenticated } = useAuth();
//   const [searchQuery, setSearchQuery] = useState("");
//   const [selectedSpecialty, setSelectedSpecialty] = useState("all");
//   const [locationFilter, setLocationFilter] = useState("");
//   const [availabilityFilter, setAvailabilityFilter] = useState("");
//   const [userLocation, setUserLocation] = useState(null);
//   const [locationLoading, setLocationLoading] = useState(false);
//   const [locationError, setLocationError] = useState("");
//   const [pincodeInput, setPincodeInput] = useState("");

//   // Check if current location should show GEETH365 doctors and determine city type
//   const locationInfo = useMemo(() => {
//     // Check if user selected city-based locations
//     if (userLocation && userLocation.city) {
//       const cityName = userLocation.city.toLowerCase();
//       if (cityName.includes("visakhapatnam")) {
//         return { shouldShow: true, city: "visakhapatnam" };
//       }
//       if (cityName.includes("chittor")) {
//         return { shouldShow: true, city: "chittor" };
//       }
//       if (
//         cityName.includes("rajamahendravaram") ||
//         cityName.includes("rajahmundry")
//       ) {
//         return { shouldShow: true, city: "rajahmundry" };
//       }
//       if (cityName.includes("guntur")) {
//         return { shouldShow: true, city: "guntur" };
//       }
//       if (cityName.includes("tanuku")) {
//         return { shouldShow: true, city: "tanuku" };
//       }
//       if (cityName.includes("vijayawada")) {
//         return { shouldShow: true, city: "vijayawada" };
//       }
//       if (cityName.includes("nellore")) {
//         return { shouldShow: true, city: "nellore" };
//       }
//       if (cityName.includes("hyderabad")) {
//         return { shouldShow: true, city: "hyderabad" };
//       }
//       if (cityName.includes("bhimavaram")) {
//         return { shouldShow: true, city: "bhimavaram" };
//       }
//       if (cityName.includes("ganapavaram")) {
//         return { shouldShow: true, city: "ganapavaram" };
//       }
//     }

//     // Check pincode input for different cities
//     if (pincodeInput && pincodeInput.length === 6) {
//       const visakhapatnamPincodes = [
//         "530001",
//         "530002",
//         "530003",
//         "530004",
//         "530005",
//         "530006",
//         "530007",
//         "530008",
//         "530009",
//         "530010",
//         "530011",
//         "530012",
//         "530013",
//         "530014",
//         "530015",
//         "530016",
//         "530017",
//         "530018",
//         "530019",
//         "530020",
//         "530021",
//         "530022",
//         "530031",
//         "530032",
//         "530040",
//         "530041",
//       ];
//       if (visakhapatnamPincodes.includes(pincodeInput)) {
//         return { shouldShow: true, city: "visakhapatnam" };
//       }

//       const chittorPincodes = ["517127", "517001", "517002"];
//       if (chittorPincodes.includes(pincodeInput)) {
//         return { shouldShow: true, city: "chittor" };
//       }

//       const rajahmundryPincodes = [
//         "533104",
//         "533101",
//         "533102",
//         "533103",
//         "533105",
//       ];
//       if (rajahmundryPincodes.includes(pincodeInput)) {
//         return { shouldShow: true, city: "rajahmundry" };
//       }

//       const gunturPincodes = ["522002", "522001", "522003", "522004"];
//       if (gunturPincodes.includes(pincodeInput)) {
//         return { shouldShow: true, city: "guntur" };
//       }

//       const tanukuPincodes = ["534211", "534201", "534202"];
//       if (tanukuPincodes.includes(pincodeInput)) {
//         return { shouldShow: true, city: "tanuku" };
//       }

//       const vijayawadaPincodes = [
//         "520008",
//         "520001",
//         "520003",
//         "520010",
//         "520004",
//       ];
//       if (vijayawadaPincodes.includes(pincodeInput)) {
//         return { shouldShow: true, city: "vijayawada" };
//       }

//       const nellorePincodes = ["524003", "524001", "524002", "524004"];
//       if (nellorePincodes.includes(pincodeInput)) {
//         return { shouldShow: true, city: "nellore" };
//       }

//       const hyderabadPincodes = [
//         "500085",
//         "500001",
//         "500003",
//         "500004",
//         "500034",
//         "500081",
//       ];
//       if (hyderabadPincodes.includes(pincodeInput)) {
//         return { shouldShow: true, city: "hyderabad" };
//       }

//       const bhimavaramPincodes = ["534202", "534201", "534203"];
//       if (bhimavaramPincodes.includes(pincodeInput)) {
//         return { shouldShow: true, city: "bhimavaram" };
//       }

//       const ganapavaramPincodes = ["534198", "534197", "534199"];
//       if (ganapavaramPincodes.includes(pincodeInput)) {
//         return { shouldShow: true, city: "ganapavaram" };
//       }
//     }

//     return { shouldShow: false, city: null };
//   }, [userLocation, pincodeInput]);

//   // Filter doctors based on search criteria and location
//   const filteredDoctors = useMemo(() => {
//     let doctorsToShow = mockDoctors;

//     // Special logic: Filter doctors based on detected city
//     if (locationInfo.shouldShow) {
//       if (locationInfo.city === "visakhapatnam") {
//         doctorsToShow = mockDoctors.filter((doctor) =>
//           doctor.address.toLowerCase().includes("visakhapatnam")
//         );
//       } else if (locationInfo.city === "chittor") {
//         doctorsToShow = mockDoctors.filter((doctor) =>
//           doctor.address.toLowerCase().includes("chittor")
//         );
//       } else if (locationInfo.city === "rajahmundry") {
//         doctorsToShow = mockDoctors.filter((doctor) =>
//           doctor.address.toLowerCase().includes("rajamahendravaram")
//         );
//       } else if (locationInfo.city === "guntur") {
//         doctorsToShow = mockDoctors.filter((doctor) =>
//           doctor.address.toLowerCase().includes("guntur")
//         );
//       } else if (locationInfo.city === "tanuku") {
//         doctorsToShow = mockDoctors.filter((doctor) =>
//           doctor.address.toLowerCase().includes("tanuku")
//         );
//       } else if (locationInfo.city === "vijayawada") {
//         doctorsToShow = mockDoctors.filter((doctor) =>
//           doctor.address.toLowerCase().includes("vijayawada")
//         );
//       } else if (locationInfo.city === "nellore") {
//         doctorsToShow = mockDoctors.filter((doctor) =>
//           doctor.address.toLowerCase().includes("nellore")
//         );
//       } else if (locationInfo.city === "hyderabad") {
//         doctorsToShow = mockDoctors.filter((doctor) =>
//           doctor.address.toLowerCase().includes("hyderabad")
//         );
//       } else if (locationInfo.city === "bhimavaram") {
//         doctorsToShow = mockDoctors.filter((doctor) =>
//           doctor.address.toLowerCase().includes("bhimavaram")
//         );
//       } else if (locationInfo.city === "ganapavaram") {
//         doctorsToShow = mockDoctors.filter((doctor) =>
//           doctor.address.toLowerCase().includes("ganapavaram")
//         );
//       }
//     }

//     return doctorsToShow.filter((doctor) => {
//       const matchesSearch =
//         doctor.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
//         doctor.specialty.toLowerCase().includes(searchQuery.toLowerCase());
//       const matchesSpecialty =
//         !selectedSpecialty ||
//         selectedSpecialty === "all" ||
//         doctor.specialty === selectedSpecialty;

//       // If GEETH365 doctors should be shown for specific city, ignore location filter
//       if (locationInfo.shouldShow) {
//         return matchesSearch && matchesSpecialty;
//       } else {
//         const matchesLocation =
//           !locationFilter ||
//           doctor.address.toLowerCase().includes(locationFilter.toLowerCase());
//         return matchesSearch && matchesSpecialty && matchesLocation;
//       }
//     });
//   }, [searchQuery, selectedSpecialty, locationFilter, locationInfo]);

//   const handleBookAppointment = (doctor) => {
//     if (!isAuthenticated) {
//       // Show signup prompt for non-authenticated users
//       window.location.href = "/auth";
//       return;
//     }

//     const whatsAppLink = generateWhatsAppLink("doctor", {
//       userName: mockUser.name,
//       specialty: doctor.specialty,
//       doctorName: doctor.name,
//       preferredTime: "Today evening",
//       location: doctor.address,
//     });
//     window.open(whatsAppLink, "_blank");
//   };

//   const getUserLocation = async () => {
//     setLocationLoading(true);
//     setLocationError("");

//     try {
//       const position = await LocationService.getCurrentLocation();
//       const address = await LocationService.reverseGeocode(
//         position.lat,
//         position.lng
//       );

//       setUserLocation({
//         ...position,
//         address: address.formattedAddress,
//         city: address.city,
//       });
//       setLocationFilter(address.city);
//       setPincodeInput(address.pincode);
//     } catch (error) {
//       setLocationError(error.message);
//     } finally {
//       setLocationLoading(false);
//     }
//   };

//   const handlePincodeSearch = async (pincode) => {
//     setPincodeInput(pincode);
//     setLocationError("");

//     if (pincode.length === 6) {
//       setLocationLoading(true);
//       try {
//         const locationData = await LocationService.getLocationFromPincode(
//           pincode
//         );
//         setLocationFilter(locationData.city);
//         setUserLocation({
//           address: locationData.formattedAddress,
//           city: locationData.city,
//           state: locationData.state,
//         });
//       } catch (error) {
//         setLocationError(error.message);
//       } finally {
//         setLocationLoading(false);
//       }
//     }
//   };

//   return (
//     <div className="min-h-screen bg-gray-50">
//       {/* Header Section */}
//       <div className="bg-white shadow-sm">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
//           <div className="text-center mb-8">
//             <h1 className="text-4xl font-bold text-gray-900 mb-4">
//               Find Doctors Near You
//             </h1>
//             <p className="text-xl text-gray-600">
//               Book appointments with verified healthcare professionals
//             </p>
//           </div>

//           {/* Search and Filters */}
//           <div className="space-y-4">
//             {/* Search Bar */}
//             <div className="relative">
//               <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
//               <Input
//                 placeholder="Search doctors by name or specialty..."
//                 value={searchQuery}
//                 onChange={(e) => setSearchQuery(e.target.value)}
//                 className="pl-10 text-lg py-3"
//               />
//             </div>

//             {/* Filter Row */}
//             <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
//               <Select
//                 value={selectedSpecialty}
//                 onValueChange={setSelectedSpecialty}
//               >
//                 <SelectTrigger>
//                   <SelectValue placeholder="All Specialties" />
//                 </SelectTrigger>
//                 <SelectContent>
//                   <SelectItem value="all">All Specialties</SelectItem>
//                   {mockSpecialties.map((specialty) => (
//                     <SelectItem key={specialty.id} value={specialty.name}>
//                       {specialty.name}
//                     </SelectItem>
//                   ))}
//                 </SelectContent>
//               </Select>

//               <Input
//                 placeholder="Enter 6-digit pincode"
//                 value={pincodeInput}
//                 onChange={(e) => handlePincodeSearch(e.target.value)}
//                 maxLength={6}
//                 className={locationError ? "border-red-300" : ""}
//               />

//               <Button
//                 variant="outline"
//                 onClick={getUserLocation}
//                 disabled={locationLoading}
//                 className="border-orange-200 text-orange-600 hover:bg-orange-50"
//               >
//                 <Navigation className="w-4 h-4 mr-2" />
//                 {locationLoading ? "Getting..." : "Use GPS"}
//               </Button>

//               <Select
//                 value={availabilityFilter}
//                 onValueChange={setAvailabilityFilter}
//               >
//                 <SelectTrigger>
//                   <SelectValue placeholder="Availability" />
//                 </SelectTrigger>
//                 <SelectContent>
//                   <SelectItem value="all">All Times</SelectItem>
//                   <SelectItem value="today">Available Today</SelectItem>
//                   <SelectItem value="tomorrow">Available Tomorrow</SelectItem>
//                 </SelectContent>
//               </Select>

//               <Button className="bg-orange-600 hover:bg-orange-700">
//                 <Filter className="w-4 h-4 mr-2" />
//                 Apply Filters
//               </Button>
//             </div>

//             {/* Location Status */}
//             {(userLocation || locationError) && (
//               <div
//                 className={`p-3 rounded-lg ${
//                   locationError
//                     ? "bg-red-50 border border-red-200"
//                     : "bg-green-50 border border-green-200"
//                 }`}
//               >
//                 <div className="flex items-center space-x-2">
//                   {locationError ? (
//                     <AlertCircle className="w-4 h-4 text-red-600" />
//                   ) : (
//                     <MapPin className="w-4 h-4 text-green-600" />
//                   )}
//                   <span
//                     className={`text-sm ${
//                       locationError ? "text-red-700" : "text-green-700"
//                     }`}
//                   >
//                     {locationError || `Location: ${userLocation.address}`}
//                   </span>
//                 </div>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>

//       {/* Location Banner */}
//       <div className="bg-orange-50 border-b">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
//           <div className="flex items-center justify-between">
//             <div className="flex items-center space-x-4">
//               <div className="flex items-center space-x-2 text-orange-600">
//                 <Navigation className="w-5 h-5" />
//                 <span className="font-medium">Current Location:</span>
//               </div>
//               <Badge
//                 variant="outline"
//                 className="border-orange-200 text-orange-700"
//               >
//                 <MapPin className="w-4 h-4 mr-1" />
//                 {userLocation
//                   ? userLocation.address
//                   : "10-68, PM Palem, Visakhapatnam - 530041"}
//               </Badge>
//               {locationInfo.shouldShow && (
//                 <Badge className="bg-green-100 text-green-700 border-green-200">
//                   ✨ Showing all GEETH365 doctors for{" "}
//                   {locationInfo.city === "visakhapatnam"
//                     ? "Visakhapatnam"
//                     : locationInfo.city === "chittor"
//                     ? "Chittor"
//                     : locationInfo.city === "rajahmundry"
//                     ? "Rajahmundry"
//                     : locationInfo.city === "guntur"
//                     ? "Guntur"
//                     : locationInfo.city === "tanuku"
//                     ? "Tanuku"
//                     : locationInfo.city === "vijayawada"
//                     ? "Vijayawada"
//                     : locationInfo.city === "nellore"
//                     ? "Nellore"
//                     : locationInfo.city === "hyderabad"
//                     ? "Hyderabad"
//                     : locationInfo.city === "bhimavaram"
//                     ? "Bhimavaram"
//                     : locationInfo.city === "ganapavaram"
//                     ? "Ganapavaram"
//                     : "Your City"}
//                 </Badge>
//               )}
//             </div>
//             <Button
//               variant="outline"
//               size="sm"
//               className="text-orange-600 border-orange-200 hover:bg-orange-50"
//             >
//               Change Location
//             </Button>
//           </div>
//         </div>
//       </div>

//       {/* Results Section */}
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
//         {/* Sign Up Encouragement Banner for Non-Authenticated Users */}
//         {!isAuthenticated && (
//           <Card className="mb-6 border-orange-200 bg-gradient-to-r from-orange-50 to-orange-100">
//             <CardContent className="p-6">
//               <div className="flex items-center justify-between">
//                 <div className="flex items-center space-x-4">
//                   <div className="bg-orange-200 p-3 rounded-full">
//                     <Crown className="w-6 h-6 text-orange-600" />
//                   </div>
//                   <div>
//                     <h3 className="text-lg font-semibold text-gray-900">
//                       Get Premium Benefits
//                     </h3>
//                     <p className="text-gray-600">
//                       Sign up free to get priority booking and exclusive
//                       discounts
//                     </p>
//                   </div>
//                 </div>
//                 <Link to="/auth">
//                   <Button className="bg-orange-600 hover:bg-orange-700">
//                     <UserPlus className="w-4 h-4 mr-2" />
//                     Sign Up Free
//                   </Button>
//                 </Link>
//               </div>
//             </CardContent>
//           </Card>
//         )}

//         <div className="flex items-center justify-between mb-6">
//           <h2 className="text-2xl font-semibold text-gray-900">
//             {filteredDoctors.length} Doctors Found
//           </h2>
//           <Select defaultValue="distance">
//             <SelectTrigger className="w-48">
//               <SelectValue />
//             </SelectTrigger>
//             <SelectContent>
//               <SelectItem value="distance">Sort by Distance</SelectItem>
//               <SelectItem value="rating">Sort by Rating</SelectItem>
//               <SelectItem value="experience">Sort by Experience</SelectItem>
//             </SelectContent>
//           </Select>
//         </div>

//         {/* Doctors Grid */}
//         <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
//           {filteredDoctors.map((doctor) => (
//             <Card
//               key={doctor.id}
//               className="hover:shadow-lg transition-all duration-300 border-orange-100"
//             >
//               <CardContent className="p-6">
//                 <div className="flex items-start space-x-4">
//                   {/* Doctor Photo */}
//                   <div className="relative">
//                     <img
//                       src={doctor.photo}
//                       alt={doctor.name}
//                       className="w-24 h-24 rounded-full object-cover border-4 border-orange-100"
//                     />
//                     <div className="absolute -bottom-2 -right-2 bg-green-500 w-6 h-6 rounded-full border-2 border-white flex items-center justify-center">
//                       <div className="w-2 h-2 bg-white rounded-full"></div>
//                     </div>
//                   </div>

//                   {/* Doctor Info */}
//                   <div className="flex-1">
//                     <div className="flex items-start justify-between mb-2">
//                       <div>
//                         <h3 className="text-xl font-semibold text-gray-900">
//                           {doctor.name}
//                         </h3>
//                         <p className="text-orange-600 font-medium">
//                           {doctor.specialty}
//                         </p>
//                       </div>
//                       <div className="flex items-center space-x-1">
//                         <Star className="w-4 h-4 fill-yellow-400 text-yellow-400" />
//                         <span className="font-medium">{doctor.rating}</span>
//                       </div>
//                     </div>

//                     <div className="space-y-2 mb-4">
//                       <div className="flex items-center space-x-2 text-sm text-gray-600">
//                         <Stethoscope className="w-4 h-4" />
//                         <span>
//                           {typeof doctor.experience === "number"
//                             ? `${doctor.experience} years experience`
//                             : doctor.experience}
//                         </span>
//                       </div>
//                       <div className="flex items-center space-x-2 text-sm text-gray-600">
//                         <MapPin className="w-4 h-4" />
//                         <span>
//                           {doctor.clinic}, {doctor.address}
//                         </span>
//                       </div>
//                       <div className="flex items-center space-x-2 text-sm text-gray-600">
//                         <Navigation className="w-4 h-4" />
//                         <span>{doctor.distance} away</span>
//                       </div>
//                     </div>

//                     {/* Achievements */}
//                     <div className="flex flex-wrap gap-2 mb-4">
//                       {doctor.achievements
//                         .slice(0, 2)
//                         .map((achievement, index) => (
//                           <Badge
//                             key={index}
//                             variant="outline"
//                             className="text-xs border-orange-200 text-orange-700"
//                           >
//                             <Award className="w-3 h-3 mr-1" />
//                             {achievement}
//                           </Badge>
//                         ))}
//                     </div>

//                     {/* Availability */}
//                     <div className="flex items-center space-x-2 mb-4">
//                       <Clock className="w-4 h-4 text-green-600" />
//                       <span className="text-sm text-green-600 font-medium">
//                         Available Today
//                       </span>
//                       <Badge className="bg-green-100 text-green-700 text-xs">
//                         Next: 2:30 PM
//                       </Badge>
//                     </div>

//                     {/* Action Buttons */}
//                     <div className="flex space-x-3">
//                       {isAuthenticated ? (
//                         <Button
//                           onClick={() => handleBookAppointment(doctor)}
//                           className="flex-1 bg-orange-600 hover:bg-orange-700"
//                         >
//                           <Phone className="w-4 h-4 mr-2" />
//                           Book on WhatsApp
//                         </Button>
//                       ) : (
//                         <Link to="/auth" className="flex-1">
//                           <Button className="w-full bg-orange-600 hover:bg-orange-700">
//                             <UserPlus className="w-4 h-4 mr-2" />
//                             Sign Up for Free to Book
//                           </Button>
//                         </Link>
//                       )}
//                       <Button
//                         variant="outline"
//                         className="border-orange-200 text-orange-600"
//                       >
//                         View Profile
//                       </Button>
//                     </div>

//                     {/* Phone Visible */}
//                     <div className="mt-3 pt-3 border-t border-gray-100">
//                       <p className="text-sm text-gray-600">
//                         Call directly:{" "}
//                         <span className="font-medium text-gray-900">
//                           {doctor.phone}
//                         </span>
//                       </p>
//                     </div>
//                   </div>
//                 </div>
//               </CardContent>
//             </Card>
//           ))}
//         </div>

//         {/* No Results */}
//         {filteredDoctors.length === 0 && (
//           <div className="text-center py-12">
//             <Stethoscope className="w-16 h-16 text-gray-300 mx-auto mb-4" />
//             <h3 className="text-xl font-semibold text-gray-900 mb-2">
//               No doctors found
//             </h3>
//             <p className="text-gray-600 mb-6">
//               Try adjusting your search filters or location
//             </p>
//             <Button
//               variant="outline"
//               onClick={() => {
//                 setSearchQuery("");
//                 setSelectedSpecialty("all");
//                 setLocationFilter("");
//               }}
//               className="border-orange-200 text-orange-600"
//             >
//               Clear All Filters
//             </Button>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default Doctors;
// // src/pages/Doctors.js
import React, {
  useState,
  useMemo,
  useEffect,
  useCallback,
  useRef,
} from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { Card, CardContent } from "../components/ui/card";
import { Input } from "../components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../components/ui/select";
import { Badge } from "../components/ui/badge";
import {
  Stethoscope,
  MapPin,
  Search,
  Filter,
  Navigation,
  UserPlus,
  Crown,
  AlertCircle,
  Frown,
  RefreshCw,
} from "lucide-react";
import { mockSpecialties } from "../mock/mockData";
import LocationService from "../services/locationService";
import { useDoctorsApi } from "../hooks/useDoctorsApi";
import DoctorCard from "@/components/ui/Doctors/DoctorCard";

const Doctors = () => {
  const { isAuthenticated } = useAuth();
  const {
    getDoctors,
    loading: doctorsLoading,
    error: doctorsError,
  } = useDoctorsApi();

  const [doctors, setDoctors] = useState([]);
  const [hasFetched, setHasFetched] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedSpecialty, setSelectedSpecialty] = useState("all");
  const [locationFilter, setLocationFilter] = useState("");
  const [availabilityFilter, setAvailabilityFilter] = useState("");
  const [userLocation, setUserLocation] = useState(null);
  const [locationLoading, setLocationLoading] = useState(false);
  const [locationError, setLocationError] = useState("");
  const [pincodeInput, setPincodeInput] = useState("");

  // Use ref to track if fetch is in progress
  const fetchInProgress = useRef(false);

  // Fetch doctors on component mount - only once
  const fetchDoctors = useCallback(
    async (params = {}) => {
      // If we're performing a standard initial fetch and we've already fetched, skip
      // But if params are provided (like GPS), we want to proceed
      if (
        (hasFetched && Object.keys(params).length === 0) ||
        fetchInProgress.current
      )
        return;

      try {
        fetchInProgress.current = true;
        console.log("Fetching doctors with params:", params);
        const response = await getDoctors(params);
        if (response?.status === 200 && response.data?.doctors) {
          setDoctors(response.data.doctors);
          setHasFetched(true);
          console.log(
            "Doctors fetched successfully:",
            response.data.doctors.length
          );
        }
      } catch (error) {
        console.error("Failed to fetch doctors:", error);
        setHasFetched(true); // Mark as fetched even on error to prevent retries
      } finally {
        fetchInProgress.current = false;
      }
    },
    [getDoctors, hasFetched]
  );

  useEffect(() => {
    fetchDoctors();
  }, [fetchDoctors]);


  // Check if current location should show GEETH365 doctors and determine city type
  const locationInfo = useMemo(() => {
    // Check if user selected city-based locations
    if (userLocation && userLocation.city) {
      const cityName = userLocation.city.toLowerCase();
      if (cityName.includes("visakhapatnam")) {
        return { shouldShow: true, city: "visakhapatnam" };
      }
      if (cityName.includes("chittor")) {
        return { shouldShow: true, city: "chittor" };
      }
      if (
        cityName.includes("rajamahendravaram") ||
        cityName.includes("rajahmundry")
      ) {
        return { shouldShow: true, city: "rajahmundry" };
      }
      if (cityName.includes("guntur")) {
        return { shouldShow: true, city: "guntur" };
      }
      if (cityName.includes("tanuku")) {
        return { shouldShow: true, city: "tanuku" };
      }
      if (cityName.includes("vijayawada")) {
        return { shouldShow: true, city: "vijayawada" };
      }
      if (cityName.includes("nellore")) {
        return { shouldShow: true, city: "nellore" };
      }
      if (cityName.includes("hyderabad")) {
        return { shouldShow: true, city: "hyderabad" };
      }
      if (cityName.includes("bhimavaram")) {
        return { shouldShow: true, city: "bhimavaram" };
      }
      if (cityName.includes("ganapavaram")) {
        return { shouldShow: true, city: "ganapavaram" };
      }
    }

    // Check pincode input for different cities
    if (pincodeInput && pincodeInput.length === 6) {
      const visakhapatnamPincodes = [
        "530001",
        "530002",
        "530003",
        "530004",
        "530005",
        "530006",
        "530007",
        "530008",
        "530009",
        "530010",
        "530011",
        "530012",
        "530013",
        "530014",
        "530015",
        "530016",
        "530017",
        "530018",
        "530019",
        "530020",
        "530021",
        "530022",
        "530031",
        "530032",
        "530040",
        "530041",
      ];
      if (visakhapatnamPincodes.includes(pincodeInput)) {
        return { shouldShow: true, city: "visakhapatnam" };
      }

      const chittorPincodes = ["517127", "517001", "517002"];
      if (chittorPincodes.includes(pincodeInput)) {
        return { shouldShow: true, city: "chittor" };
      }

      const rajahmundryPincodes = [
        "533104",
        "533101",
        "533102",
        "533103",
        "533105",
      ];
      if (rajahmundryPincodes.includes(pincodeInput)) {
        return { shouldShow: true, city: "rajahmundry" };
      }

      const gunturPincodes = ["522002", "522001", "522003", "522004"];
      if (gunturPincodes.includes(pincodeInput)) {
        return { shouldShow: true, city: "guntur" };
      }

      const tanukuPincodes = ["534211", "534201", "534202"];
      if (tanukuPincodes.includes(pincodeInput)) {
        return { shouldShow: true, city: "tanuku" };
      }

      const vijayawadaPincodes = [
        "520008",
        "520001",
        "520003",
        "520010",
        "520004",
      ];
      if (vijayawadaPincodes.includes(pincodeInput)) {
        return { shouldShow: true, city: "vijayawada" };
      }

      const nellorePincodes = ["524003", "524001", "524002", "524004"];
      if (nellorePincodes.includes(pincodeInput)) {
        return { shouldShow: true, city: "nellore" };
      }

      const hyderabadPincodes = [
        "500085",
        "500001",
        "500003",
        "500004",
        "500034",
        "500081",
      ];
      if (hyderabadPincodes.includes(pincodeInput)) {
        return { shouldShow: true, city: "hyderabad" };
      }

      const bhimavaramPincodes = ["534202", "534201", "534203"];
      if (bhimavaramPincodes.includes(pincodeInput)) {
        return { shouldShow: true, city: "bhimavaram" };
      }

      const ganapavaramPincodes = ["534198", "534197", "534199"];
      if (ganapavaramPincodes.includes(pincodeInput)) {
        return { shouldShow: true, city: "ganapavaram" };
      }
    }

    return { shouldShow: false, city: null };
  }, [userLocation, pincodeInput]);

  // Filter doctors based on search criteria and location
  const filteredDoctors = useMemo(() => {
    let doctorsToShow = doctors;

    // Apply search and specialty filters
    const filtered = doctorsToShow.filter((doctor) => {
      const matchesSearch =
        doctor.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        doctor.specialty?.toLowerCase().includes(searchQuery.toLowerCase());
      const matchesSpecialty =
        !selectedSpecialty ||
        selectedSpecialty === "all" ||
        doctor.specialty === selectedSpecialty;

      // If GEETH365 doctors should be shown for specific city, ignore location filter
      if (locationInfo.shouldShow) {
        return matchesSearch && matchesSpecialty;
      } else {
        const matchesLocation =
          !locationFilter ||
          (doctor.address &&
            doctor.address
              .toLowerCase()
              .includes(locationFilter.toLowerCase()));
        return matchesSearch && matchesSpecialty && matchesLocation;
      }
    });

    return filtered;
  }, [doctors, searchQuery, selectedSpecialty, locationFilter, locationInfo]);

  const getUserLocation = async () => {
    setLocationLoading(true);
    setLocationError("");

    try {
      const position = await LocationService.getCurrentLocation();
      const address = await LocationService.reverseGeocode(
        position.lat,
        position.lng
      );

      setUserLocation({
        ...position,
        address: address.formattedAddress,
        city: address.city,
      });
      setLocationFilter(address.city);
      setPincodeInput(address.pincode);

      // Fetch doctors with coordinates
      await fetchDoctors({ lat: position.lat, lon: position.lng });
    } catch (error) {
      setLocationError(error.message);
    } finally {
      setLocationLoading(false);
    }
  };

  // Auto-detect user location on page load
  useEffect(() => {
    // Only auto-detect if we haven't already detected location
    if (!userLocation && !locationError) {
      getUserLocation();
    }
  }, []);

  const handlePincodeSearch = async (pincode) => {
    setPincodeInput(pincode);
    setLocationError("");

    if (pincode.length === 6) {
      setLocationLoading(true);
      try {
        const locationData = await LocationService.getLocationFromPincode(
          pincode
        );
        setLocationFilter(locationData.city);
        setUserLocation({
          address: locationData.formattedAddress,
          city: locationData.city,
          state: locationData.state,
        });
      } catch (error) {
        setLocationError(error.message);
      } finally {
        setLocationLoading(false);
      }
    }
  };

  const handleRetry = () => {
    setHasFetched(false);
    fetchDoctors();
  };

  const isLoading = doctorsLoading || locationLoading;

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header Section */}
      <div className="bg-white shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="text-center mb-8">
            <h1 className="text-4xl font-bold text-gray-900 mb-4">
              Find Doctors Near You
            </h1>
            <p className="text-xl text-gray-600">
              Book appointments with verified healthcare professionals
            </p>
          </div>

          {/* Search and Filters */}
          <div className="space-y-4">
            {/* Search Bar */}
            <div className="relative">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
              <Input
                placeholder="Search doctors by name or specialty..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="pl-10 text-lg py-3"
                disabled={isLoading}
              />
            </div>

            {/* Filter Row */}
            <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
              <Select
                value={selectedSpecialty}
                onValueChange={setSelectedSpecialty}
                disabled={isLoading}
              >
                <SelectTrigger>
                  <SelectValue placeholder="All Specialties" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="all">All Specialties</SelectItem>
                  {[...mockSpecialties]
                    .sort((a, b) => a.name.localeCompare(b.name))
                    .map((specialty) => (
                    <SelectItem key={specialty.id} value={specialty.name}>
                      {specialty.name}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>

              <Input
                placeholder="Enter 6-digit pincode"
                value={pincodeInput}
                onChange={(e) => handlePincodeSearch(e.target.value)}
                maxLength={6}
                className={locationError ? "border-red-300" : ""}
                disabled={isLoading}
              />

              <Button
                variant="outline"
                onClick={getUserLocation}
                disabled={isLoading}
                className="border-orange-200 text-orange-600 hover:bg-orange-50"
              >
                <Navigation className="w-4 h-4 mr-2" />
                {locationLoading ? "Getting..." : "Use GPS"}
              </Button>

              <Select
                value={availabilityFilter}
                onValueChange={setAvailabilityFilter}
                disabled={isLoading}
              >
                <SelectTrigger>
                  <SelectValue placeholder="Availability" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="all">All Times</SelectItem>
                  <SelectItem value="today">Available Today</SelectItem>
                  <SelectItem value="tomorrow">Available Tomorrow</SelectItem>
                </SelectContent>
              </Select>

              <Button
                className="bg-orange-600 hover:bg-orange-700"
                disabled={isLoading}
              >
                <Filter className="w-4 h-4 mr-2" />
                Apply Filters
              </Button>
            </div>

            {/* Location Status */}
            {(userLocation || locationError) && (
              <div
                className={`p-3 rounded-lg ${locationError
                    ? "bg-red-50 border border-red-200"
                    : "bg-green-50 border border-green-200"
                  }`}
              >
                <div className="flex items-center space-x-2">
                  {locationError ? (
                    <AlertCircle className="w-4 h-4 text-red-600" />
                  ) : (
                    <MapPin className="w-4 h-4 text-green-600" />
                  )}
                  <span
                    className={`text-sm ${locationError ? "text-red-700" : "text-green-700"
                      }`}
                  >
                    {locationError || `Location: ${userLocation.address}`}
                  </span>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Location Banner */}
      <div className="bg-orange-50 border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2 sm:space-x-4 w-full sm:w-auto">
              <div className="flex items-center space-x-2 text-orange-600 shrink-0">
                <Navigation className="w-5 h-5" />
                <span className="font-medium">Current Location:</span>
              </div>
              {userLocation ? (
                <Badge
                  variant="outline"
                  className="border-orange-200 text-orange-700 flex items-start text-left h-auto py-1.5"
                >
                  <MapPin className="w-4 h-4 mr-1 shrink-0 mt-0.5" />
                  <span>{userLocation.address}</span>
                </Badge>
              ) : (
                <Button
                  variant="outline"
                  size="sm"
                  onClick={getUserLocation}
                  disabled={locationLoading}
                  className="border-orange-200 text-orange-600 hover:bg-orange-50 animate-pulse w-full sm:w-auto"
                >
                  <Navigation className="w-4 h-4 mr-1" />
                  {locationLoading ? "Detecting..." : "📍 Detect My Location"}
                </Button>
              )}
            </div>
            <Button
              variant="outline"
              size="sm"
              onClick={getUserLocation}
              className="text-orange-600 border-orange-200 hover:bg-orange-50 w-full sm:w-auto shrink-0"
              disabled={isLoading}
            >
              {userLocation ? "Change Location" : "Detect Location"}
            </Button>
          </div>
        </div>
      </div>

      {/* Results Section */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Sign Up Encouragement Banner for Non-Authenticated Users */}
        {!isAuthenticated && (
          <Card className="mb-6 border-orange-200 bg-gradient-to-r from-orange-50 to-orange-100">
            <CardContent className="p-6">
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-4">
                  <div className="bg-orange-200 p-3 rounded-full">
                    <Crown className="w-6 h-6 text-orange-600" />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-900">
                      Get Premium Benefits
                    </h3>
                    <p className="text-gray-600">
                      Sign up free to get priority booking and exclusive
                      discounts
                    </p>
                  </div>
                </div>
                <Link to="/auth">
                  <Button
                    className="bg-orange-600 hover:bg-orange-700"
                    disabled={isLoading}
                  >
                    <UserPlus className="w-4 h-4 mr-2" />
                    Sign Up Free
                  </Button>
                </Link>
              </div>
            </CardContent>
          </Card>
        )}

        <div className="flex items-center justify-between mb-6">
          <h2 className="text-2xl font-semibold text-gray-900">
            {doctorsLoading
              ? "Loading doctors..."
              : `${filteredDoctors.length} Doctors Found`}
          </h2>
          <Select defaultValue="distance" disabled={isLoading}>
            <SelectTrigger className="w-48">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="distance">Sort by Distance</SelectItem>
              <SelectItem value="rating">Sort by Rating</SelectItem>
              <SelectItem value="experience">Sort by Experience</SelectItem>
            </SelectContent>
          </Select>
        </div>

        {/* Loading State */}
        {doctorsLoading && (
          <div className="text-center py-12">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-orange-600 mx-auto mb-4"></div>
            <p className="text-gray-600">Loading doctors...</p>
          </div>
        )}

        {/* 401 Unauthorized Error State */}
        {doctorsError && doctorsError.includes("401") && (
          <div className="text-center py-12 bg-red-50 rounded-lg">
            <AlertCircle className="w-16 h-16 text-red-400 mx-auto mb-4" />
            <h3 className="text-xl font-semibold text-gray-900 mb-2">
              Authentication Required
            </h3>
            <p className="text-gray-600 mb-4">Please log in to view doctors</p>
            <Link to="/auth">
              <Button className="bg-orange-600 hover:bg-orange-700 mr-4">
                Login to Continue
              </Button>
            </Link>
            <Button variant="outline" onClick={handleRetry}>
              <RefreshCw className="w-4 h-4 mr-2" />
              Try Again
            </Button>
          </div>
        )}

        {/* Other API Error State */}
        {doctorsError && !doctorsError.includes("401") && (
          <div className="text-center py-12 bg-red-50 rounded-lg">
            <AlertCircle className="w-16 h-16 text-red-400 mx-auto mb-4" />
            <h3 className="text-xl font-semibold text-gray-900 mb-2">
              Failed to load doctors
            </h3>
            <p className="text-gray-600 mb-6">{doctorsError}</p>
            <Button
              onClick={handleRetry}
              className="bg-orange-600 hover:bg-orange-700"
            >
              <RefreshCw className="w-4 h-4 mr-2" />
              Try Again
            </Button>
          </div>
        )}

        {/* No Doctors Available State */}
        {!doctorsLoading && !doctorsError && doctors.length === 0 && (
          <div className="text-center py-12 bg-blue-50 rounded-lg">
            <Frown className="w-16 h-16 text-blue-400 mx-auto mb-4" />
            <h3 className="text-xl font-semibold text-gray-900 mb-2">
              No Doctors Available
            </h3>
            <p className="text-gray-600 mb-6">
              We're working on adding doctors in your area. Please check back
              later.
            </p>
            <div className="flex justify-center space-x-4">
              <Button
                onClick={handleRetry}
                variant="outline"
                className="border-orange-200 text-orange-600"
              >
                <RefreshCw className="w-4 h-4 mr-2" />
                Refresh
              </Button>
              <Link to="/auth">
                <Button className="bg-orange-600 hover:bg-orange-700">
                  <UserPlus className="w-4 h-4 mr-2" />
                  Sign Up for Updates
                </Button>
              </Link>
            </div>
          </div>
        )}

        {/* No Search Results State */}
        {!doctorsLoading &&
          !doctorsError &&
          doctors.length > 0 &&
          filteredDoctors.length === 0 && (
            <div className="text-center py-12">
              <Search className="w-16 h-16 text-gray-300 mx-auto mb-4" />
              <h3 className="text-xl font-semibold text-gray-900 mb-2">
                No doctors match your search
              </h3>
              <p className="text-gray-600 mb-6">
                Try adjusting your search filters or location
              </p>
              <Button
                variant="outline"
                onClick={() => {
                  setSearchQuery("");
                  setSelectedSpecialty("all");
                  setLocationFilter("");
                }}
                className="border-orange-200 text-orange-600"
              >
                Clear All Filters
              </Button>
            </div>
          )}

        {/* Doctors Grid */}
        {!doctorsLoading && !doctorsError && filteredDoctors.length > 0 && (
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            {filteredDoctors.map((doctor) => (
              <DoctorCard key={doctor.id} doctor={doctor} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Doctors;
